//  Angular imports
import { Injectable } from '@angular/core';
//  Application imports
import { FortiCloudBaseProvisioningService } from './base-provisioning.service';
import { Endpoints } from './endpoints';
//  Third party imports
import { Observable } from 'rxjs';
import { RAuditQueryResponse } from 'app/records/audit.record';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AuditInfoService extends FortiCloudBaseProvisioningService {

    public getAudits(accountId: number,
        serialNumber: string, lastKey: string): Observable<RAuditQueryResponse> {

        const parameters = lastKey ? new HttpParams().set('lastKey', lastKey) : null;

        return this.apiGet<RAuditQueryResponse>(
            `${Endpoints.AUDIT}/${accountId}/${serialNumber}`,
            RAuditQueryResponse, false, parameters
        ) as Observable<RAuditQueryResponse>;
    }
}
